import { apiClient } from "@/lib/auth";

export const api = apiClient;
export const API = apiClient.defaults.baseURL;

// Plants
export const listPlants = (params = {}) => api.get("/plants", { params }).then((r) => r.data);
export const getPlant = (id) => api.get(`/plants/${id}`).then((r) => r.data);
export const createPlant = (payload) => api.post("/plants", payload).then((r) => r.data);
export const updatePlant = (id, payload) => api.put(`/plants/${id}`, payload).then((r) => r.data);
export const deletePlant = (id) => api.delete(`/plants/${id}`).then((r) => r.data);

// Beds
export const listBeds = () => api.get("/beds").then((r) => r.data);
export const createBed = (payload) => api.post("/beds", payload).then((r) => r.data);
export const updateBed = (id, payload) => api.put(`/beds/${id}`, payload).then((r) => r.data);
export const deleteBed = (id) => api.delete(`/beds/${id}`).then((r) => r.data);

// Stats
export const getStats = () => api.get("/stats").then((r) => r.data);

// Almanack & Catalogue (public)
export const getAlmanack = () => api.get("/almanack").then((r) => r.data);
export const getCatalogue = () => api.get("/catalogue").then((r) => r.data);
export const refreshCatalogue = () => api.post("/admin/catalogue/refresh").then((r) => r.data);

// Contact (public)
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
